import React from "react";
import { useNavigate } from "react-router-dom";
import CommonTable from "components/commonTable/CommonTable";
import CityConfigForm from "./CityConfigForm";

const cityRideTypesData = {
  header: [
    { label: "City Name", key: "city" },
    { label: "No. Ride Types", key: "rideTypeCount" },
    { label: "Ride Types", key: "tags" },
  ],
  body: [
    {
      id: 1,
      city: "Mumbai",
      rideTypeCount: 3,
      tags: ["Ride", "Airport", "Outstation", "Rental"],
    },
    {
      id: 2,
      city: "Bangalore",
      rideTypeCount: 4,
      tags: ["Ride", "Airport", "Rental", "Outstation"],
    },
    {
      id: 3,
      city: "Chennai",
      rideTypeCount: 2,
      tags: ["Ride", "Airport", "Rental", "Outstation"],
    },
  ],
  totalCount: 3,
};

const CityRideTypesTable = () => {
  const navigate = useNavigate();
  const handleRowClick = (row) => {
    navigate(`/city-config/${row.city}`);
  };

  return (
    <CommonTable
      data={cityRideTypesData}
      page={0}
      rowsPerPage={10}
      handleChangePage={() => {}}
      handleChangeRowsPerPage={() => {}}
      onClickTableVendor={handleRowClick}
      isClickable={true}
    />
  );
};

function RateCardV1() {
  return (
    <div>
      {/* <h3>Cities Configuration Dashboard</h3> */}
      <h3>Rate Card</h3>
      {/* <CityRideTypesTable /> */}
      <CityConfigForm />
    </div>
  );
}

export default RateCardV1;